import { useTranslation } from 'react-i18next';
import { useGetNotificationsQuery } from '@customer/store/apis/notificationsApi';
import NewNotifications from './new-notifications/NewNotifications';
import { VdsButton } from '@volt/volt-extended-components-react';
import { useCallback } from 'react';
import { closeSidePanel } from '@customer/store/slices/globalSlice';
import { useAppDispatch } from '@customer/store/hooks';
import { DrawerPanel } from '@dmc/ui';
import Tabs from '@cas/components/tabs/tabs/Tabs';
import useTabs, { TabConfig } from '@cas/components/tabs/tabs/useTabs';

export function NotificationsPanel() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const { data } = useGetNotificationsQuery(undefined, {
    refetchOnMountOrArgChange: 600,
  });

  const onClose = useCallback(() => {
    dispatch(closeSidePanel());
  }, [dispatch]);

  const hasNewNotifications = !!data?.newCount;

  const tabConfigs: TabConfig[] = [
    {
      title: t('New'),
      view: <NewNotifications />,
      isDotted: hasNewNotifications,
    },
  ];

  const { tabs, activeTab, activeView, onSelectTab } = useTabs({ tabConfigs });

  return (
    <DrawerPanel
      header={t('Notifications')}
      tabs={<Tabs tabs={tabs} activeTab={activeTab} onSelectTab={onSelectTab} hasBorder />}
      footer={
        <VdsButton onClick={onClose} variant="secondary" size="medium" isFullWidth>
          {t('Close')}
        </VdsButton>
      }
    >
      {activeView}
    </DrawerPanel>
  );
}

export default NotificationsPanel;
